import { render, staticRenderFns } from "./nickName.vue?vue&type=template&id=3c38db0f&scoped=true&"
import script from "./nickName.vue?vue&type=script&lang=js&"
export * from "./nickName.vue?vue&type=script&lang=js&"
import style0 from "./nickName.vue?vue&type=style&index=0&id=3c38db0f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c38db0f",
  null
  
)

export default component.exports